import React from 'react';
import { LogOut, AlertTriangle } from 'lucide-react';
import { Button } from '../../components/core';

interface LogoutModalProps {
  isOpen: boolean;
  username: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const LogoutModal: React.FC<LogoutModalProps> = ({ isOpen, username, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9990] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
      <div className="w-full max-w-md animate-in fade-in zoom-in space-y-5 rounded-2xl border border-slate-800 bg-slate-900 p-6 text-slate-100 shadow-2xl duration-200">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-rose-800/60 bg-rose-950">
            <AlertTriangle className="h-5 w-5 text-rose-400" />
          </div>
          <div>
            <h3 className="text-base font-extrabold text-white">Confirm Logout</h3>
            <p className="mt-0.5 text-xs text-slate-400">End active administrative session</p>
          </div>
        </div>

        <p className="rounded-xl border border-slate-800/80 bg-slate-950 p-3.5 text-xs leading-relaxed text-slate-300">
          Are you sure you want to log out, <strong className="text-white">{username}</strong>? Unsaved form drafts will be discarded.
        </p>

        <div className="flex justify-end gap-3 pt-2">
          <Button type="button" variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="button" variant="danger" leftIcon={LogOut} onClick={onConfirm}>
            Confirm Logout
          </Button>
        </div>
      </div>
    </div>
  );
};
